import React from 'react'

interface SkeletonMultiplierProps {
  /** The components to be rendered inside the component */
  children: React.ReactNode
  /** The number of times to repeat the children */
  quantity?: number
  /**
   * A wrapper component or HTML tag to wrap each repeated `children`.
   * @default React.Fragment
   */
  wrapper?: React.ElementType
}

const SkeletonMultiplier = ({ quantity = 4, wrapper, children }: SkeletonMultiplierProps) => {
  const Component = wrapper ?? React.Fragment

  return [...new Array(quantity)].map((_, index) => (
    <Component key={`skeleton${index}`}>{children}</Component>
  ))
}

export default SkeletonMultiplier
